import {IKuPiperCore as IKuPiperCoreBase} from '@baidu/ku-piper-core';

import store from './helpers/store';
import buried from './helpers/buried';
import server from './helpers/server';
import components from './helpers/components';
import utils from './helpers/utils';
import auth from './helpers/auth';
import loadable from './helpers/loadable';

import {ENVIRONMENT_LEVEL} from '@/Constant';

import kuPiperInstance, {IKuPiperMapOptions} from './core';

interface IKuPiperOptions extends IKuPiperMapOptions {
    /**
     * 从知识库代码引入
     */
    store: typeof store; // 状态存储
    buried: typeof buried; // 埋点
    server: typeof server; // 接口请求方法
    utils: typeof utils; // 公共方法
    components: typeof components; // 公共组件
    auth: typeof auth; // 权限模型
    loadable: typeof loadable; // 异步加载
}

const instance = kuPiperInstance as IKuPiperCoreBase<IKuPiperOptions>;

// 增加外部引入
instance.store = store;
instance.buried = buried;
instance.server = server;
instance.utils = utils;
instance.components = components;
instance.auth = auth;
instance.loadable = loadable;

// 非线上环境，kuPiper挂载到window，方便调试
if (process.env.REACT_APP_ENVIRONMENT !== ENVIRONMENT_LEVEL.online) {
    (window as any).kuPiper = instance;
}

// 这东西多少是有点恶心了……但是只能这么把外部引入的类型给出去
export type IKuPiper = typeof instance;

export default instance;
